<template>
  <div>
    <div class="popup" v-if="visible">
      <div class="w-420px">
        <img src="../assets/images/icons/popup-content.png" alt="popup-content" class="w-420px">
        <img src="../assets/images/icons/popup-close.png" alt="popup-close" @click="close" class="mx-auto block w-50px cursor-pointer">
      </div>
    </div>
    <img @click="show" src="../assets/images/icons/popup-btn.png" alt="popup-btn" class="fixed bottom-200px right-86px z-10 w-150px cursor-pointer <sm:hidden">
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

defineOptions({
  name: 'PageHomePopup',
});

const visible = ref(false);

const close = () => {
  visible.value = false
}

const show = () => {
  visible.value = true
}
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
